import React from 'react';
import Select from 'react-select';

const DropDown = (props: any) => {
  return (
    <Select
      isSearchable={false}
      {...props}
      theme={(theme: { colors: any; spacing: any; }) => {
        return {
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            text: 'black',
            primary: '#525c72',
          },
          spacing: {
            ...theme.spacing,
            menuGutter: 0,
          },
        };
      }}
      styles={{
        container: (provided: any, state: any) => ({
          ...provided,
          cursor: 'pointer',
        }),
        dropdownIndicator: (provided: any, state: { isFocused: any; }) => ({
          ...provided,
          color: state.isFocused ? '#248ab7' : '#d9d9d9',
          '&:hover': {
            color: state.isFocused ? '#248ab7' : '#0000004d',
          },
        }),
        control: (provided: any, state: { isFocused: any; }) => ({
          ...provided,
          borderColor: state.isFocused ? '#248ab7' : '#d9d9d9',
          boxShadow: '',
          cursor: 'pointer',
          borderRadius: '.4rem',
          '&:hover': {
            borderColor: state.isFocused ? '#248ab7' : '#0000004d',
          },
        }),
        indicatorSeparator: () => ({}),
        menu: (provided: any, state: any) => ({
          ...provided,
          marginTop: 0,
          cursor: 'pointer',
        }),
        menuList: (provided: any, state: any) => ({
          ...provided,
          cursor: 'pointer',
        }),
        option: (provided: any, state: any) => ({
          ...provided,
          cursor: 'pointer',
        }),
      }}
    />
  );
};

export default DropDown;